import { components, useApi } from "@appretio/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidateCubeMutation } from "../cubeMutationInvalidation";

type CloneBrandInput = components["schemas"]["CloneBrandInput"];

export function useCloneBrand() {
  const apiClient = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (input: CloneBrandInput) => {
      const response = await apiClient.POST("/v2/forecast/cubes/clone-brand", {
        body: input
      });
      if (!response.data?.result) {
        throw new Error("Missing result in clone brand response");
      }
      return response.data.result;
    },
    onSuccess: async () => {
      await invalidateCubeMutation(queryClient, { lifecycle: true });
    },
    meta: {
      errorMessage: "Failed to clone brand"
    }
  });
}
